import * as React from 'react';
import { CaretRight } from '@liveauctioneers/hammer-ui-core/icons/v2';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Select } from '@liveauctioneers/hammer-ui-core/select';
import Facet from './Facet';
import Facets from '@/types/search/enums/facetTypes';

type Props = {
    className?: string;
    loadPageWithFacetCollapsed: boolean;
    onChangeYearRange: Function;
};

const getYearOptions = (minYear, maxYear) => {
    let yearOpts = [];
    for (let i = minYear; i <= maxYear; i = i + 1) {
        yearOpts.push({ key: i, label: i, value: i });
    }
    return yearOpts;
};

const AuctionDateFacet = (props: Props) => {
    const { className, loadPageWithFacetCollapsed, onChangeYearRange } = props;
    const maxTs = Date.now();
    const minTs = new Date('1999/1/1').getTime();
    const startMinYear = new Date(minTs).getFullYear();
    const startMaxYear = new Date(maxTs).getFullYear();
    const [minYear, setMinYear] = React.useState<number | string>(startMinYear);
    const [maxYear, setMaxYear] = React.useState<number | string>(startMaxYear);
    const yearClickHandler = () => {
        const minTimeStamp = new Date(`${minYear}-1/1`).getTime() / 1000;
        const maxTimeStamp = new Date(`${maxYear}-12/31 23:59:59`).getTime() / 1000;

        onChangeYearRange(Facets.SALE_START, minTimeStamp, maxTimeStamp);
    };

    React.useEffect(() => {
        setMinYear(startMinYear);
    }, [startMinYear]);

    React.useEffect(() => {
        setMaxYear(startMaxYear);
    }, [startMaxYear]);

    const minYearOptions = getYearOptions(startMinYear, maxYear);
    const maxYearOptions = getYearOptions(minYear, startMaxYear);

    return (
        <Facet
            className={className}
            closeFacet={loadPageWithFacetCollapsed}
            title={<FormattedMessage id="search_facet_title_saleStart" />}
        >
            <div className="flex items-center justify-between">
                <Select
                    id="startYear"
                    onChange={(e) => setMinYear(e.value)}
                    options={minYearOptions}
                    small
                    value={{ key: minYear, label: minYear, value: minYear }}
                />{' '}
                -{' '}
                <Select
                    id="endYear"
                    onChange={(e) => setMaxYear(e.value)}
                    options={maxYearOptions}
                    small
                    value={{ key: maxYear, label: maxYear, value: maxYear }}
                />
                <IconButton
                    icon={CaretRight}
                    onClick={yearClickHandler}
                    shape="square"
                    size="sm"
                    style="primary"
                    variant="filled"
                />
            </div>
        </Facet>
    );
};

export default AuctionDateFacet;
